import { useEffect, useState } from 'react';

/** Matches `$mobile-max` in the SCSS. Keep the two in step. */
const MOBILE_MAX_WIDTH = 767;

/**
 * True while the viewport is phone-sized.
 *
 * Starts `false` and only flips in an effect, so server-side and jsdom renders
 * get the desktop layout. Components that need a genuinely different structure
 * on mobile (not just different styling) use this; anything that can be done in
 * a media query should stay in the stylesheet.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= MOBILE_MAX_WIDTH);

    check();
    window.addEventListener('resize', check);

    return () => window.removeEventListener('resize', check);
  }, []);

  return isMobile;
}
